const ns = '[Siderbar] ';

export const CHANGE_CATEGORY = `${ns}change symbol category`;
export const TOGGLE_PIN = `${ns}toggle pin`;
export const SET_PIN = `${ns}set pin`;
